module.exports = __webpack_public_path__ + "img/escudo_maipu.32d4bc5a.png";